document.addEventListener(
	'DOMContentLoaded',
	function () {
		const scrollToTopButtons = document.querySelectorAll('.go-to-the-top');
		scrollToTopButtons.forEach(button => {
			button.addEventListener('click', scrollToTop);
		});

		function scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	},
	false
);